import { IPlanThoiGianHocLopHC } from "../../model/respone/category/IPlanThoiGianHocLopHC";
import { apiClient } from "../apiClient";

export const THOI_GIAN_HOC_LOP_HC_API = "thoi-gian-hoc-lop-hc";
export const thoiGianHocLopHCApi = {
  SelectAll: () => apiClient.get(`${THOI_GIAN_HOC_LOP_HC_API}`),
  Insert: (payload: IPlanThoiGianHocLopHC) => apiClient.post(`${THOI_GIAN_HOC_LOP_HC_API}`, payload),
  Update: (payload: IPlanThoiGianHocLopHC) => apiClient.put(`${THOI_GIAN_HOC_LOP_HC_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${THOI_GIAN_HOC_LOP_HC_API}/${id}`),
};
